import fetcher from 'api/fetcher';
import { parseISO } from 'date-fns';
import { ChangeHistoryType } from 'utils/constants/admin';

import { EventType, setEvents, setShowModal, setType } from 'store/models/changeHistory';
import { AppThunkAction } from 'store/utils';

export const fetchActHistory = (actId: number): AppThunkAction => {
    return (dispatch) => {
        return fetcher
            .get<unknown, EventType[]>(`/api/v1/acts/${actId}/change`)
            .then((actHistory) => {
                actHistory.sort((a, b) => parseISO(a.changeTime).getTime() - parseISO(b.changeTime).getTime());
                dispatch([setShowModal(true), setEvents(actHistory), setType(ChangeHistoryType.Act)]);
            })
            .catch((error) => {
                console.error('Fetch Act History', JSON.stringify(error));
            });
    };
};
